import { ISiteUserProps } from "@pnp/sp/site-users/types";
import BaseService from "./base.service";

export interface ISPWebService {
    getLogo(): Promise<string>;
    ensureUser(email: string): Promise<ISiteUserProps>;
}

export default class SPWebService extends BaseService implements ISPWebService {

    public async getLogo(): Promise<string> {
        if(this.params){
            const spContext = await this.getSPContext();
            const webInfo = await spContext.web.select("SiteLogoUrl").get();
            return webInfo.SiteLogoUrl; 
        }
    }
    public async ensureUser(email: string): Promise<ISiteUserProps> {
        const spContext = await this.getSPContext();
        const userInfo = await spContext.web.ensureUser(email);
        return userInfo.data;
    }
} 